import {
	AdAccountDTO,
	AssetDTO,
	ProductAccountDTO,
	isDisconnectedAdAccount
} from 'api-models'
import { AppButton, Banner } from '@clickguard/design-system'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAccountStore, useAssetStore } from 'store'
import { useShallow } from 'zustand/react/shallow'

export const shouldShowDisconnectedAccountBanner = (
	account: ProductAccountDTO | null | undefined,
	asset: AssetDTO | null | undefined,
	adAccounts: AdAccountDTO[],
	demoMode: boolean
): boolean =>
	!demoMode &&
	account?.status === 'ACTIVE' &&
	account.setup?.step === 'SETUP_COMPLETE' &&
	account.billing?.subscription?.status !== 'CANCELLING' &&
	!!asset &&
	asset.account_id === account.id &&
	adAccounts.some(
		(adAccount) =>
			adAccount.account_id === account.id &&
			adAccount.asset_id === asset.id &&
			isDisconnectedAdAccount(adAccount)
	)

export const DisconnectedAccountBanner = () => {
	const account = useAccountStore((state) => state.account)
	const { asset, adAccounts, demoMode } = useAssetStore(
		useShallow((state) => ({
			asset: state.asset,
			adAccounts: state.adAccounts,
			demoMode: state.demoMode
		}))
	)
	const { pathname } = useLocation()
	const navigate = useNavigate()
	const routeAccountId = pathname.match(/\/workspace\/([^/]+)/)?.[1]
	const routeAssetId = pathname.match(/\/asset\/([^/]+)/)?.[1]
	if (
		!shouldShowDisconnectedAccountBanner(
			account,
			asset,
			adAccounts,
			demoMode
		) ||
		(routeAccountId && routeAccountId !== account?.id) ||
		(routeAssetId && routeAssetId !== asset?.id)
	)
		return null

	return (
		<div className="px-4 pt-4">
			<Banner
				title="Your ad account is disconnected"
				description="Please reconnect to resume protection. It only takes a minute."
				tone="warning"
				actions={
					<AppButton
						label="Reconnect account"
						size="sm"
						onClick={() =>
							navigate(
								`/settings/workspace/${account!.id}/asset/${
									asset!.id
								}/connections`
							)
						}
					/>
				}
			/>
		</div>
	)
}
